// @flow

export const getViewportWidth = fallback => () => {
  if (!document || !document.documentElement) {
    return fallback;
  }
  return Math.max(document.documentElement.clientWidth, window.innerWidth || 0);
};

const addDomReadyCallback = (fn) => {
  if (document.readyState === 'interactive' || document.readyState === 'complete') {
    fn();
    return;
  }

  // Mozilla, Opera, Webkit
  if (document.addEventListener) {
    document.addEventListener('DOMContentLoaded', () => {
      fn();
    }, false);

  // If IE event model is used
  } else if (document.attachEvent) {
  // ensure firing before onload
    document.attachEvent('onreadystatechange', () => {
      if (document.readyState === 'complete') {
        fn();
      }
    });
  }
};

export const domready = fn => (document.readyState === 'interactive' || document.readyState === 'complete' ? fn() : addDomReadyCallback(fn));

// Cookie creation with no additional options
export const createCookie = (name: string, value: string): void => {
  const expires = '';
  document.cookie = `${name}=${encodeURIComponent(value)}${expires}; path=/;domain=${process.env.REACT_APP_COOKIE_DOMAIN};`;
};

export const getCookie = (name: string): string|false => {
  if (document.cookie.length > 0) {
    let cookieStart = document.cookie.indexOf(`${name}=`);
    if (cookieStart !== -1) {
      cookieStart = cookieStart + name.length + 1;
      let cookieEnd = document.cookie.indexOf(';', cookieStart);
      if (cookieEnd === -1) {
        cookieEnd = document.cookie.length;
      }
      return unescape(document.cookie.substring(cookieStart, cookieEnd));
    }
  }

  return false;
};

export const addScript = (dataAttrs: Object) => (url: string): Promise<Event> => new Promise((res, rej) => {
  const script = document.createElement('script');
  script.type = 'text/javascript';
  script.src = url;
  Object.keys(dataAttrs)
    .map(key => script.setAttribute(key, dataAttrs[key]));

  document.body.appendChild(script);

  script.onload = res;
  script.onerror = rej;
});



// WEBPACK FOOTER //
// ./src/helpers/browser.js